import { ETaskStatus } from '@constants';
import { ISection } from '@sdk/contracts';
import { FC } from 'react';

import { Wrapper } from './PendingReviewDot.styles';

import { useProfile } from '@/store';

type Props = {
  section: ISection;
};

export const PendingReviewDot: FC<Props> = ({ section }) => {
  const {
    profile,
    roleCheck: { isTeacher, isManager }
  } = useProfile();

  const areTasksPendingByTeacher =
    isTeacher &&
    section.activities.some(
      activity =>
        activity.task &&
        activity.task.statusInfo.currentStatus !== ETaskStatus.APPROVED &&
        activity.task.assignee._id === profile?._id
    );
  if (areTasksPendingByTeacher) return <Wrapper />;

  const areTasksPendingByManager =
    isManager &&
    section.activities.some(
      activity => activity.task && activity.task.statusInfo.currentStatus !== ETaskStatus.APPROVED
    );
  if (areTasksPendingByManager) return <Wrapper />;

  return null;
};
